import { Injectable, signal } from '@angular/core';

/**
 * Bridges the current flow's interpolation variables to the formula editor.
 * The flow-editor (features) publishes the available `{{...}}` keys here; the
 * code-editor field (core) reads them, keeping core decoupled from features.
 */
@Injectable({
  providedIn: 'root',
})
export class FormulaVariablesService {
  readonly #variables = signal<string[]>([]);

  public setVariables(variables: string[]): void {
    this.#variables.set(variables);
  }

  public getVariables(): string[] {
    return this.#variables();
  }
}
